module.exports = __webpack_public_path__ + "img/warnIcon.783b20eb.svg";